module.exports = __webpack_public_path__ + "img/18.1518ab69.png";